import { dollarsToCents, safeDate, undefinedIfNull } from '../misc';
import { DELIVERY_ADDRESS_TYPE } from '../../../src/constants/deliveryAddress';

export default function processMember(rawMember: RawMember): Member {
  return {
    id: String(rawMember.ID),
    memberNumber: rawMember.MemberNo,
    givenName: undefinedIfNull(rawMember.GivenNames),
    surname: undefinedIfNull(rawMember.Surname),
    fullName:
      (rawMember.GivenNames ?? '') +
      (rawMember.GivenNames && rawMember.Surname ? ' ' : '') +
      (rawMember.Surname ?? ''),
    email: undefinedIfNull(rawMember.Email),
    mobile: undefinedIfNull(rawMember.Mobile),
    verified: Boolean(rawMember.VerificationDate),
    moneyBalance: dollarsToCents(rawMember.Money),
    pointsBalance: rawMember.Points,
    // pretty sure this shouldn't need to exist and is incorrect
    // rewards are supposed to be equivalent to dollars and are stored as such in tbl_members in the same field as points
    // rewardsBalance: dollarsToCents(rawMember.Points), // TODO: check this is the case
    active: Boolean(rawMember.Active),
    verifyPin: undefinedIfNull(rawMember.VerifyPIN),
    type: (rawMember.CardType || '').toUpperCase(),
    expiryDate: safeDate(rawMember.ExpiryDate) as string,
    registered: Boolean(rawMember.RegistrationDate),
    cardsetId: String(rawMember.CardsetID),
    barcode: String(rawMember.Barcode),
    dateOfBirth: undefinedIfNull(rawMember.DateOfBirth),
    phone: undefinedIfNull(rawMember.Phone),
    savedAddresses: rawMember.SavedDeliveryAddresses?.map(rawAddress => {
      const deliveryDropOffCoordinates: PositionCoordinates | undefined =
        rawAddress.DeliveryDropOffLongitude &&
        rawAddress.DeliveryDropOffLatitude
          ? {
              latitude: rawAddress.DeliveryDropOffLatitude,
              longitude: rawAddress.DeliveryDropOffLongitude,
            }
          : undefined;

      return {
        addressId: rawAddress.ID,
        addressComponents: {
          country: rawAddress.Country,
          postCode: rawAddress.Postcode,
          state: rawAddress.State,
          streetName: rawAddress.Address1,
          streetNumber: rawAddress.Address2,
          suburb: rawAddress.Suburb,
        },
        addressType: rawAddress.AddressType ?? DELIVERY_ADDRESS_TYPE.OTHER,
        buildingInformation: rawAddress.BuildingInformation,
        deliveryInstruction: rawAddress.DeliveryInstructions,
        deliveryNotes: rawAddress.DeliveryNotes,
        locationName: rawAddress.Alias,
        displayAddress: {
          firstLine: rawAddress.Address1,
          secondLine: rawAddress.Address2,
        },
        formattedAddress:
          rawAddress.FormattedAddress ??
          `${rawAddress.Address1} ${rawAddress.Address2}`,
        location: {
          latitude: rawAddress.Latitude,
          longitude: rawAddress.Longitude,
        },
        deliveryDropOffCoordinates,
        placeId: rawAddress.GooglePlaceID,
      } as DeliveryAddress;
    }),

    tfaAuthMode: rawMember.TFAAuthMode,
    stampcardText: rawMember.StampcardText,
    stampsEarned: rawMember.StampsEarned,
    stampcardsFilled: rawMember.StampcardsFilled,
    acceptedTOS: rawMember.AcceptedTOS,
  };
}
